import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { VariantContextData } from "../variants/VariantBuilderContext";
import {
  hideCanvasSelectLabel,
  showCanvasSelectLabel,
} from "../../utils/canvasSelectLabel";
import {
  collectPanelBreadcrumbAncestors,
  sectionPanelLabel,
  columnPositionName,
  elementPanelLabel,
} from "../../utils/panelNavigationUtils";

const VariantBuilderPanelBreadcrumb = (props) => {
  const [contextData, builder] = useContext(VariantContextData);

  function selectObject(object_type, object_id, column) {
    hideCanvasSelectLabel();

    builder.select(object_type, object_id, column ? "Design" : null, column);
  }

  function breadcrumbSelectors(object_type, object_id, column) {
    if (object_type === "steps") {
      return {
        divSelector: '.canvas[data-step-id="' + object_id + '"]',
        labelSelector:
          '.select-label[data-object_type="steps"][data-object_id="' +
          object_id +
          '"]',
      };
    }

    if (object_type === "sections" && column) {
      return {
        divSelector:
          '.cf-column[data-section-id="' +
          object_id +
          '"][data-column-position="' +
          column +
          '"]',
        labelSelector:
          '.select-label[data-object_type="sections"][data-object_id="' +
          object_id +
          '"][data-column="' +
          column +
          '"]',
      };
    }

    if (object_type === "sections") {
      return {
        divSelector: '.cf-section-overlay[data-section-id="' + object_id + '"]',
        labelSelector:
          '.select-label[data-object_type="sections"][data-object_id="' +
          object_id +
          '"]',
      };
    }

    if (object_type === "section_columns") {
      return {
        divSelector:
          '.cf-flex-column[data-section-column-id="' + object_id + '"]',
        labelSelector:
          '.select-label[data-object_type="section_columns"][data-object_id="' +
          object_id +
          '"]',
      };
    }

    if (object_type === "elements") {
      return {
        divSelector: '.cf-element[data-id="' + object_id + '"]',
        labelSelector:
          '.select-label[data-object_type="elements"][data-object_id="' +
          object_id +
          '"]',
      };
    }

    return { divSelector: null, labelSelector: null };
  }

  function renderBreadcrumbCrumb(crumb, index) {
    const { divSelector, labelSelector } = breadcrumbSelectors(
      crumb.object_type,
      crumb.object_id,
      crumb.column
    );
    const isNested = index > 0;

    return (
      <span
        key={`breadcrumb-${crumb.object_type}-${crumb.object_id}-${crumb.column || index}`}
        className={isNested ? "options-panel-breadcrumbs-nested" : undefined}
        onClick={(e) =>
          selectObject(crumb.object_type, crumb.object_id, crumb.column)
        }
        data-div-selector={divSelector}
        data-label-selector={labelSelector}
      >
        {isNested && (
          <span
            className="glyphicon glyphicon-menu-right"
            aria-hidden="true"
          ></span>
        )}{" "}
        {crumb.label}
      </span>
    );
  }

  let breadcrumbs = [];

  if (props.object_type == "steps") {
    breadcrumbs.push(
      <span
        key="breadcrumb-steps-"
        onClick={() => {
          $('[data-tab="steps"]').trigger("click");
        }}
      >
        Funnel
      </span>
    );

    breadcrumbs.push(
      <span
        key={"breadcrumb-steps-" + props.object.id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => {
          selectObject("steps", props.object.id);
        }}
        data-div-selector={'.canvas[data-step-id="' + props.object.id + '"]'}
        data-label-selector={
          '.select-label[data-object_type="steps"][data-object_id="' +
          props.object.id +
          '"]'
        }
      >
        <span
          className="glyphicon glyphicon-menu-right"
          aria-hidden="true"
        ></span>{" "}
        Step {props.object.position}
      </span>
    );
  }

  if (props.object_type == "sections" && !props.object.element_id) {
    let step = contextData.objects.variant.steps[props.object.step_id];
    if (!step) return;

    breadcrumbs.push(
      <span
        key="breadcrumb-steps-"
        onClick={() => {
          $('[data-tab="steps"]').trigger("click");
        }}
      >
        Funnel
      </span>
    );

    breadcrumbs.push(
      <span
        key={"breadcrumb-steps-" + props.object.step_id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => selectObject("steps", props.object.step_id)}
        data-div-selector={
          '.canvas[data-step-id="' + props.object.step_id + '"]'
        }
        data-label-selector={
          '.select-label[data-object_type="steps"][data-object_id="' +
          props.object.step_id +
          '"]'
        }
      >
        <span
          className="glyphicon glyphicon-menu-right"
          aria-hidden="true"
        ></span>{" "}
        Step {step.position}
      </span>
    );

    if (!props.object.element_id) {
      breadcrumbs.push(
        <span
          key={"breadcrumb-sections-" + props.object.id}
          className="options-panel-breadcrumbs-nested"
          onClick={(e) => selectObject("sections", props.object.id)}
          data-div-selector={
            '.cf-section-overlay[data-section-id="' + props.object.id + '"]'
          }
          data-label-selector={
            '.select-label[data-object_type="sections"][data-object_id="' +
            props.object.id +
            '"]'
          }
        >
          <span
            className="glyphicon glyphicon-menu-right"
            aria-hidden="true"
          ></span>{" "}
          Section
        </span>
      );
    }

    if (props.object.element_id) {
      let section_id =
        contextData.objects.variant.elements[props.object.element_id]
          .section_id;
      breadcrumbs.push(
        <span
          key={"breadcrumb-sections-" + section_id}
          className="options-panel-breadcrumbs-nested"
          onClick={(e) => selectObject("sections", section_id)}
          data-div-selector={
            '.cf-section-overlay[data-section-id="' + section_id + '"]'
          }
          data-label-selector={
            '.select-label[data-object_type="sections"][data-object_id="' +
            section_id +
            '"]'
          }
        >
          <span
            className="glyphicon glyphicon-menu-right"
            aria-hidden="true"
          ></span>{" "}
          Section
        </span>
      );
    }
  }

  if (props.object_type == "section_columns") {
    const ancestors = collectPanelBreadcrumbAncestors(
      contextData.objects.variant,
      builder.get_object_parent_layer,
      "section_columns",
      props.object.id
    );

    ancestors.forEach((crumb, index) => {
      breadcrumbs.push(renderBreadcrumbCrumb(crumb, index));
    });

    breadcrumbs.push(
      renderBreadcrumbCrumb(
        {
          object_type: "section_columns",
          object_id: props.object.id,
          label: `Column ${props.object.position || props.object.id}`,
        },
        ancestors.length
      )
    );
  }

  if (props.object_type == "sections" && props.object.element_id) {
    const ancestors = collectPanelBreadcrumbAncestors(
      contextData.objects.variant,
      builder.get_object_parent_layer,
      "sections",
      props.object.id
    );

    ancestors.forEach((crumb, index) => {
      breadcrumbs.push(renderBreadcrumbCrumb(crumb, index));
    });

    breadcrumbs.push(
      renderBreadcrumbCrumb(
        {
          object_type: "sections",
          object_id: props.object.id,
          label: sectionPanelLabel(props.object),
        },
        ancestors.length
      )
    );
  }

  if (props.object_type == "elements") {
    let section = contextData.objects.variant.sections[props.object.section_id];
    if (!section) return;

    const ancestors = collectPanelBreadcrumbAncestors(
      contextData.objects.variant,
      builder.get_object_parent_layer,
      "elements",
      props.object.id
    );

    ancestors.forEach((crumb, index) => {
      breadcrumbs.push(renderBreadcrumbCrumb(crumb, index));
    });

    if (!section.content_toggle_item_id) {
      breadcrumbs.push(
        renderBreadcrumbCrumb(
          {
            object_type: "sections",
            object_id: section.id,
            label: `Col ${props.object.column}`,
            column: columnPositionName(props.object.column),
          },
          breadcrumbs.length
        )
      );
    }

    breadcrumbs.push(
      renderBreadcrumbCrumb(
        {
          object_type: "elements",
          object_id: props.object.id,
          label: elementPanelLabel(props.object),
        },
        breadcrumbs.length
      )
    );
  }

  if (props.object_type == "fields" && !props.object.field_id) {
    const field = props.object;
    const fieldPosition =
      Object.values(contextData.objects.variant.fields)
        .filter(
          (f) =>
            f.element_id == field.element_id &&
            f.toBeDeleted !== true &&
            !f.field_id
        )
        .sort((a, b) => a.position - b.position)
        .findIndex((f) => f.id == field.id) + 1;
    const element = contextData.objects.variant.elements[field.element_id];
    if (!element) return;

    const column =
      element.column == 1
        ? "first"
        : element.column == 2
        ? "second"
        : element.column == 3
        ? "third"
        : element.column == 4
        ? "fourth"
        : "";

    let section = contextData.objects.variant.sections[element.section_id];
    if (!section) return;

    if (!section.content_toggle_item_id) {
      breadcrumbs.push(
        <span
          key={"breadcrumb-sections-" + section.id}
          className="options-panel-breadcrumbs-nested"
          onClick={(e) => selectObject("sections", section.id)}
          data-div-selector={
            '.cf-section-overlay[data-section-id="' + section.id + '"]'
          }
          data-label-selector={
            '.select-label[data-object_type="sections"][data-object_id="' +
            section.id +
            '"]'
          }
        >
          Section
        </span>
      );

      breadcrumbs.push(
        <span
          key={"breadcrumb-sections-" + element.id + "-column-" + column}
          className="options-panel-breadcrumbs-nested"
          onClick={(e) => selectObject("sections", element.id, column, false)}
          data-div-selector={
            '.cf-column[data-section-id="' +
            element.id +
            '"][data-column-position="' +
            column +
            '"]'
          }
          data-label-selector={
            '.select-label[data-object_type="sections"][data-object_id="' +
            element.id +
            '"][data-column="' +
            column +
            '"]'
          }
        >
          <span
            className="glyphicon glyphicon-menu-right"
            aria-hidden="true"
          ></span>{" "}
          Col {element.column}
        </span>
      );
    }

    breadcrumbs.push(
      <span
        key={"breadcrumb-elements-" + element.id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => selectObject("elements", element.id)}
        data-div-selector={'.cf-element[data-id="' + element.id + '"]'}
        data-label-selector={
          '.select-label[data-object_type="elements"][data-object_id="' +
          element.id +
          '"]'
        }
      >
        <span
          className="glyphicon glyphicon-menu-right"
          aria-hidden="true"
        ></span>{" "}
        {humanizeStr(element.element_type)}
      </span>
    );

    breadcrumbs.push(
      <span
        key={"breadcrumb-fields-" + field.id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => selectObject("fields", field.id)}
        data-div-selector={'.cf-element[data-id="' + field.id + '"]'}
        data-label-selector={
          '.select-label[data-object_type="fields"][data-object_id="' +
          field.id +
          '"]'
        }
      >
        <span
          className="glyphicon glyphicon-menu-right"
          aria-hidden="true"
        ></span>{" "}
        {`Question ${fieldPosition || field.position}`}
      </span>
    );
  }

  if (props.object_type == "fields" && props.object.field_id) {
    const element =
      contextData.objects.variant.elements[props.object.element_id];
    if (!element) return;

    const parent_field =
      contextData.objects.variant.fields[props.object.field_id];
    if (!parent_field) return;

    const field = props.object;
    const fieldPosition =
      Object.values(contextData.objects.variant.fields)
        .filter(
          (f) =>
            f.element_id == element.id && f.toBeDeleted !== true && !f.field_id
        )
        .sort((a, b) => a.position - b.position)
        .findIndex((f) => f.id == parent_field.id) + 1;
    const subFieldPosition =
      Object.values(contextData.objects.variant.fields)
        .filter((f) => f.toBeDeleted !== true && f.field_id == field.field_id)
        .sort((a, b) => a.position - b.position)
        .findIndex((f) => f.id == field.id) + 1;

    breadcrumbs.push(
      <span
        key={"breadcrumb-elements-" + element.id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => selectObject("elements", element.id)}
        data-div-selector={'.cf-element[data-id="' + element.id + '"]'}
        data-label-selector={
          '.select-label[data-object_type="elements"][data-object_id="' +
          element.id +
          '"]'
        }
      >
        {humanizeStr(element.element_type)}
      </span>
    );

    breadcrumbs.push(
      <span
        key={"breadcrumb-fields-" + parent_field.id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => selectObject("fields", parent_field.id)}
        data-div-selector={'.cf-element[data-id="' + parent_field.id + '"]'}
        data-label-selector={
          '.select-label[data-object_type="fields"][data-object_id="' +
          parent_field.id +
          '"]'
        }
      >
        <span
          className="glyphicon glyphicon-menu-right"
          aria-hidden="true"
        ></span>{" "}
        {`Question ${fieldPosition || parent_field.position}`}
      </span>
    );

    breadcrumbs.push(
      <span
        key={"breadcrumb-fields-" + field.id}
        className="options-panel-breadcrumbs-nested"
        onClick={(e) => selectObject("fields", field.id)}
        data-div-selector={'.cf-element[data-id="' + field.id + '"]'}
        data-label-selector={
          '.select-label[data-object_type="fields"][data-object_id="' +
          field.id +
          '"]'
        }
      >
        <span
          className="glyphicon glyphicon-menu-right"
          aria-hidden="true"
        ></span>{" "}
        {`Sub-Question ${subFieldPosition || field.position}`}
      </span>
    );
  }

  useEffect(() => {
    document
      .querySelectorAll(".options-panel-breadcrumbs span[data-div-selector]")
      .forEach((span) => {
        const divSelector = span.getAttribute("data-div-selector");
        const div = document.querySelector(divSelector);

        const labelSelector = span.getAttribute("data-label-selector") || "";
        const objectType = labelSelector.match(
          /data-object_type="([^"]+)"/
        )?.[1];
        const objectId = labelSelector.match(/data-object_id="([^"]+)"/)?.[1];
        const column = labelSelector.match(/data-column="([^"]+)"/)?.[1];

        span.onmouseover = function () {
          if (!div) return;
          div.classList.add("editor-select");
          showCanvasSelectLabel({
            object_type: objectType,
            object_id: objectId,
            column,
            label: span.innerText.trim(),
            object: contextData.objects.variant?.[objectType]?.[objectId],
            target: div,
          });
        };

        span.onmouseleave = function () {
          if (div) div.classList.remove("editor-select");
          hideCanvasSelectLabel();
        };
      });
  }, [
    contextData.objects.variant,
    contextData.selected_object_type,
    contextData.selected_object_id,
    contextData.selected_object_collapse,
  ]);

  return (
    <React.Fragment>
      <div className="options-panel-breadcrumbs w-full mt-4 text-lg text-slate-500 dark:text-slate-300">
        {breadcrumbs.map((breadcrumb) => {
          return breadcrumb;
        })}
      </div>
    </React.Fragment>
  );
};

export default VariantBuilderPanelBreadcrumb;
